import React from 'react';
import '../../scss/controls/_checkbutton.scss';

type CheckButtonProps = {
    id: string;
    label: string;
    icon?: React.ReactNode;
    selected: boolean;
    disabled?: boolean;
    onToggle: () => void;
    width?: string;
    hideCheckbox?: boolean;
    anchorCheckboxTop?: boolean;
};

export const CheckButton: React.FC<CheckButtonProps> = ({
    id,
    label,
    icon,
    selected,
    onToggle,
    width = 'auto',
    disabled = false,
    hideCheckbox = false,
    anchorCheckboxTop = false,
}) => {
    return (
        <label
            className={`labelButton tertiary ${selected ? 'is-checked' : ''} ${disabled ? 'disabled' : 'active'}`}
            htmlFor={id}
            onClick={(e) => e.stopPropagation()}
            style={{ width }}
        >
            <div className={`checkbox-button-content ${anchorCheckboxTop ? 'checkbox-top' : ''}`}>
                <input
                    id={id}
                    type='checkbox'
                    checked={selected}
                    onChange={onToggle}
                    disabled={disabled}
                    className={hideCheckbox ? 'checkbox-native-hidden' : 'checkbox-native'}
                />
                <span className='label'>{label}</span>
                {icon && <div className='right-icon'>{icon}</div>}
            </div>
        </label>
    );
};
